import { GetServerSideProps } from "next";
import Head from "next/head";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import VideoHighlightComponent from "@/components/videohighlight";
import { getLocale } from "@/lib/i18n-utils";

const VideoHighlightPage = () => {
  
  return (
    <>
      <Head>
        <title>AI STUDIOS - Video Highlights</title>
      </Head>
      <VideoHighlightComponent />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const locale: string = await getLocale(context);

  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
};

export default VideoHighlightPage;
